import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { SessionStorageService } from '../services/session_storage';
import { environment } from 'src/environments/environment';
import { Constants } from 'src/app/constants/constants';
import { CalAngularService } from '@cvx/cal-angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private session: SessionStorageService,
    private authService: CalAngularService,
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return new Observable(observer => {
      (async () => {
        const apiUrl = environment.apiUrl; // Use the apiUrl from environment        
        if (req.url.startsWith(apiUrl)) {
          let token = this.session.getItem(Constants.TOKEN_KEY);
          const tokenExp = this.session.getItem(Constants.TOKEN_EXPIRATION_KEY);
          const isTokenExpired = this.isTokenExpired(tokenExp);          
          if (isTokenExpired) {
            token = await this.aqireToken(); // Wait for the token to be acquired
          }          
          const cloned = req.clone({
            headers: req.headers.set('Authorization', `Bearer ${token}`)
          });
          next.handle(cloned).subscribe({
            next: (event) => observer.next(event),
            error: (err) => observer.error(err),
            complete: () => observer.complete()
          });
        } else {
          next.handle(req).subscribe({
            next: (event) => observer.next(event),
            error: (err) => observer.error(err),
            complete: () => observer.complete()
          });
        }
      })();
    });
  }

  private isTokenExpired(exp: any): boolean {
    try {
      const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
      return exp < currentTime; // Check if the token is expired
    } catch (error) {
      console.error('Failed to decode token or extract expiration time', error);
      return true; // Assume expired if decoding fails
    }
  }
  private async aqireToken(): Promise<string | null> {
    try {
      const scopes = environment.scopes;
      const result = await firstValueFrom(this.authService.getAADToken(scopes)); // Convert Observable to Promise
      const token = JSON.parse(JSON.stringify(result));
      this.session.setItem(Constants.TOKEN_KEY, token);
      const payload = JSON.parse(atob(token.split('.')[1])); // Decode the payload
      this.session.setItem(Constants.TOKEN_EXPIRATION_KEY, payload.exp);    
      return token;
    } catch (error) {
      console.error('Failed to acquire token', error);
      return null;
    }
  }
}
